import React, { Component } from "react";
import { firebase as fbConfig } from "./config";
import firebase from "firebase";
import "firebase/firestore";

import subDays from "date-fns/sub_days";

import "./App.css";

import PomTracker from "./PomTracker";
import CurrentlyWorking from "./components/CurrentlyWorking";
// import LoginForm from "./LoginForm";

firebase.initializeApp(fbConfig);
window.firebase = firebase;
const db = firebase.firestore();

class App extends Component {
  state = {
    uid: "zAUmzWCANTRolPhn33kV6HsmKmY2",
    currentPom: null,
    poms: [],
    points: [],
    daysAgo: 30,
  };

  componentDidMount() {
    const { uid, daysAgo } = this.state;

    db.collection("pomtrackers")
      .doc(uid)
      .onSnapshot(doc => {
        this.setState({ currentPom: doc.data().current_pom });
      });

    db.collection("pomtrackers")
      .doc(uid)
      .collection("points")
      .onSnapshot(snap => {
        const points = snap.docs.map(doc => ({ ...doc.data(), id: doc.id }));
        this.setState({ points });
      });

    db.collection("pomtrackers")
      .doc(uid)
      .collection("poms")
      .where("start", ">", subDays(new Date(), daysAgo))
      .onSnapshot(snap => {
        const poms = snap.docs.map(doc => ({ ...doc.data(), id: doc.id }));
        this.setState({ poms });
      });
  }

  render() {
    const { currentPom, points, poms } = this.state;

    return (
      <div>
        <CurrentlyWorking currentPom={currentPom} />

        <PomTracker poms={poms} points={points} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js